// Curated marine stabilizer catalog: brand → list of { type, kw } models.
// kW values are nominal power consumption (or motor rating for fin stabilizers).
// Brands not listed here (or "Other" via custom entry) fall back to free-text
// type and manual kW — the picker degrades gracefully.

export const STABILIZER_CATALOG = {
  "Seakeeper": [
    { type: "Seakeeper 1", kw: 1.5 },
    { type: "Seakeeper 2", kw: 2 },
    { type: "Seakeeper 3", kw: 2 },
    { type: "Seakeeper 4.5", kw: 2.5 },
    { type: "Seakeeper 5", kw: 2.5 },
    { type: "Seakeeper 6", kw: 3 },
    { type: "Seakeeper 9", kw: 4 },
    { type: "Seakeeper 16", kw: 5 },
    { type: "Seakeeper 18", kw: 6 },
    { type: "Seakeeper 26", kw: 7 },
    { type: "Seakeeper 35", kw: 9 },
    { type: "Seakeeper 40", kw: 11 },
  ],
  "ABT-TRAC": [
    { type: "TRAC 220", kw: null },
    { type: "TRAC 250", kw: null },
    { type: "TRAC 375", kw: null },
    { type: "TRAC 500", kw: null },
    { type: "TRAC 1500", kw: null },
  ],
  "CMC Marine": [
    { type: "Stabilis Electra 35", kw: null },
    { type: "Stabilis Electra 45", kw: null },
    { type: "Stabilis Electra 60", kw: null },
    { type: "Stabilis Electra 100", kw: null },
    { type: "Argo", kw: null },
  ],
  "DMS Holland": [
    { type: "MagnusMaster MM45", kw: null },
    { type: "MagnusMaster MM55", kw: null },
    { type: "MagnusMaster MM75", kw: null },
    { type: "AntiRoll AR250", kw: null },
    { type: "AntiRoll AR450", kw: null },
  ],
  "Humphree": [
    { type: "Interceptor Active 300", kw: null },
    { type: "Interceptor Active 500", kw: null },
    { type: "Interceptor Active 750", kw: null },
    { type: "Interceptor Active 1000", kw: null },
    { type: "Interceptor Active 1300", kw: null },
  ],
  "Naiad Dynamics": [
    { type: "Naiad 252", kw: null },
    { type: "Naiad 302", kw: null },
    { type: "Naiad 452", kw: null },
    { type: "Naiad 525", kw: null },
    { type: "Naiad 717", kw: null },
  ],
  "Quantum Stabilizers": [
    { type: "QC1100", kw: null },
    { type: "QC1400", kw: null },
    { type: "QC1800", kw: null },
    { type: "QC2200", kw: null },
    { type: "XT Series", kw: null },
  ],
  "Smartgyro": [
    { type: "SG40", kw: 2.5 },
    { type: "SG80", kw: 4 },
    { type: "SG120", kw: 5 },
  ],
  "VEEM": [
    { type: "VG260SD", kw: null },
    { type: "VG500SD", kw: null },
    { type: "VG750SD", kw: null },
    { type: "VG1100SD", kw: null },
  ],
  "WESMAR": [
    { type: "DSP-300", kw: null },
    { type: "DSP-500", kw: null },
    { type: "DSP-1000", kw: null },
    { type: "DSP-3000", kw: null },
  ],
  "Mitsubishi": [
    { type: "ARG 175", kw: null },
    { type: "ARG 250", kw: null },
    { type: "ARG 375", kw: null },
  ],
  "Quick": [
    { type: "MC² X2", kw: 1.5 },
    { type: "MC² X3", kw: 2 },
    { type: "MC² X4", kw: 2.5 },
    { type: "MC² X7", kw: 3.5 },
    { type: "MC² X10", kw: 4.5 },
  ],
};
